import { render } from "./ListaUtenti.vue?vue&type=template&id=4a5386ae&ts=true"
import script from "./ListaUtenti.vue?vue&type=script&lang=ts"
export * from "./ListaUtenti.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__